"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewChat = void 0;
/* eslint-disable import/prefer-default-export */
var react_1 = __importDefault(require("react"));
var NewChat = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("path", { d: "M11.867 4.05165H6.08499C4.98042 4.05165 4.08499 4.94708 4.08499 6.05165V18.2143C4.08499 19.3189 4.98042 20.2143 6.08499 20.2143H17.649C18.7536 20.2143 19.649 19.3189 19.649 18.2143V11.2351M16.6559 4.05165C17.8248 2.88278 20.8179 5.87586 19.649 7.04474C19.0504 7.64335 12.4656 14.2281 12.4656 14.2281L8.87393 15.4254L9.47254 11.2351C9.47254 11.2351 16.0573 4.65027 16.6559 4.05165Z", stroke: color, strokeWidth: "1.25", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.NewChat = NewChat;
